export default "__VITE_ASSET__DrpxXOV8__"